"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_popover_1 = require("@radix-ui/react-popover");
const constants_1 = require("../constants");
const Content = (0, styled_1.default)(react_popover_1.Content)({
    zIndex: constants_1.theme.zIndex.popover,
});
const Popover = (props) => {
    return (0, jsx_runtime_1.jsx)(react_popover_1.Root, { ...props });
};
exports.Popover = Popover;
exports.Popover.Trigger = react_popover_1.Trigger;
exports.Popover.Content = Content;
